var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGitlabLogoSimple = function SvgIconGitlabLogoSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.24 3.608a1.375 1.375 0 0 1 1.356.881l.003.007L8.474 9.5h7.051l1.878-5.011a1.375 1.375 0 0 1 2.613.137l2.569 9.61.005.022a1.77 1.77 0 0 1-.69 1.855l-.012.01-8.89 6.15a1.76 1.76 0 0 1-1.997 0l-8.89-6.15-.012-.01a1.77 1.77 0 0 1-.69-1.855l.006-.023 2.569-9.609A1.38 1.38 0 0 1 5.24 3.608m.172 3.42-2.018 7.55L12 20.531l8.606-5.955-2.018-7.549-1.433 3.823a1 1 0 0 1-.937.649H7.781a1 1 0 0 1-.936-.65z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGitlabLogoSimple;